var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsDateString, IsIP, IsObject, IsString, IsUUID } from 'class-validator';
import { UserProfileDto } from '../../user/index.js';
export class PatientvideoConsentDeclarationFullSizeDto {
    id;
    createdAt;
    updatedAt;
    privacyVersion;
    ipAddress;
    user;
    userId;
    exerciseId;
}
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", String)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "privacyVersion", void 0);
__decorate([
    IsIP(),
    Expose(),
    __metadata("design:type", String)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "ipAddress", void 0);
__decorate([
    IsObject(),
    Type(() => UserProfileDto),
    Exclude(),
    __metadata("design:type", Function)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "user", void 0);
__decorate([
    Exclude(),
    IsUUID(),
    __metadata("design:type", String)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "userId", void 0);
__decorate([
    Expose(),
    IsUUID(),
    __metadata("design:type", String)
], PatientvideoConsentDeclarationFullSizeDto.prototype, "exerciseId", void 0);
//# sourceMappingURL=patientvideo-consent-declaration.full-size.dto.js.map